// Turkish labels for codes that come from apps/api.

export const STAFF_STATUS: Record<string, { label: string; color: string }> = {
  active: { label: "Aktif", color: "green" },
  invited: { label: "Davet bekliyor", color: "gold" },
  deactivated: { label: "Devre dışı", color: "default" },
};

export const AUDIT_ACTIONS: Record<string, string> = {
  "staff.invite": "Ekip üyesi davet edildi",
  "staff.reinvite": "Davet yenilendi",
  "invitation.accept": "Davet kabul edildi",
  "staff.roles": "Roller değiştirildi",
  "staff.activate": "Ekip üyesi etkinleştirildi",
  "staff.deactivate": "Ekip üyesi devre dışı bırakıldı",
  "staff.update": "Ekip üyesinin bilgileri değişti",
  "staff.remove": "Ekip üyesi silindi",
  "role.create": "Rol oluşturuldu",
  "role.update": "Rol değiştirildi",
  "role.delete": "Rol silindi",
  "tutor.approve": "Eğitmen başvurusu onaylandı",
  "tutor.reject": "Eğitmen başvurusu reddedildi",
  "tutor.reopen": "Eğitmen başvurusu tekrar incelemeye alındı",
  "tutor.deactivate": "Eğitmen pasife alındı",
  "tutor.reactivate": "Eğitmen tekrar aktif edildi",
  "tutorChange.approve": "Eğitmenin profil değişikliği onaylandı",
  "tutorChange.reject": "Eğitmenin profil değişikliği reddedildi",
  "review.approve": "Yorum yayına alındı",
  "review.reject": "Yorum reddedildi",
  "cancellation.approve": "Eğitmenin iptal talebi onaylandı",
  "cancellation.reject": "Eğitmenin iptal talebi reddedildi",
  "payout.ibanView": "Ödeme için IBAN görüntülendi",
  "tutor.payoutInfoView": "Eğitmenin IBAN'ı görüntülendi",
  "student.contactView": "Öğrencinin iletişim ve veli bilgisi görüntülendi",
  "payout.markPaid": "Ödeme talebi ödendi olarak işaretlendi",
  "conversation.view": "Bildirilen sohbet okundu",
  "conversationReport.resolve": "Sohbet bildirimi sonuçlandırıldı",
  "conversation.close": "Sohbet kapatıldı",
  "plan.create": "Plan eklendi",
  "plan.update": "Plan değiştirildi",
  "season.create": "Dönem eklendi",
  "season.update": "Dönem değiştirildi",
  "pricing.apply": "Fiyat modeli uygulandı",
  "blogPost.create": "Blog yazısı eklendi",
  "blogPost.update": "Blog yazısı değiştirildi",
  "blogPost.delete": "Blog yazısı silindi",
  "blogAuthor.create": "Blog yazarı eklendi",
  "blogAuthor.update": "Blog yazarı değiştirildi",
  "blogAuthor.delete": "Blog yazarı silindi",
  "blogCategory.create": "Blog kategorisi eklendi",
  "blogCategory.update": "Blog kategorisi değiştirildi",
  "blogCategory.delete": "Blog kategorisi silindi",
  "systemError.status": "Sistem hatasının durumu değiştirildi",
  "lessonRecording.view": "Ders kaydı izlendi",
  "order.refund": "Öğrenci ödemesi iade edildi",
  "pricing.feeUpdate": "Ödeme komisyonu güncellendi (fiyatlar değişmedi)",
  "tutor-agreement.notified": "Eğitmene sözleşme değişikliği bildirildi",
};

export const REPORT_REASONS: Record<string, string> = {
  HARASSMENT: "Taciz veya hakaret",
  OFF_PLATFORM: "Platform dışına yönlendirme",
  INAPPROPRIATE: "Uygunsuz içerik",
  OTHER: "Diğer",
};

/** "Soru Çözüm": why a student reported an answer. */
export const QUESTION_REPORT_REASONS: Record<string, string> = {
  WRONG_ANSWER: "Çözüm yanlış",
  UNCLEAR: "Anlaşılmıyor",
  INAPPROPRIATE: "Uygunsuz içerik",
  OTHER: "Diğer",
};

export const REPORT_STATUS: Record<string, { label: string; color: string }> = {
  OPEN: { label: "Açık", color: "orange" },
  RESOLVED: { label: "Sonuçlandı", color: "green" },
};

export const AUDIT_TARGETS: Record<string, string> = {
  StaffUser: "Ekip üyesi",
  StaffRole: "Rol",
  TutorProfile: "Eğitmen",
  Review: "Yorum",
  Lesson: "Ders",
  TutorPayout: "Ödeme talebi",
  Conversation: "Sohbet",
  Plan: "Plan",
  PricingModel: "Fiyat modeli",
  BlogPost: "Blog yazısı",
  BlogAuthor: "Blog yazarı",
  BlogCategory: "Blog kategorisi",
  ConversationReport: "Sohbet bildirimi",
  StudentProfile: "Öğrenci",
  SystemError: "Sistem hatası",
};

export const ERROR_STATUS: Record<string, { label: string; color: string }> = {
  unresolved: { label: "Çözülmedi", color: "red" },
  resolved: { label: "Çözüldü", color: "green" },
  ignored: { label: "Yok sayıldı", color: "default" },
};

/** GlitchTip projects: which app the error came from. */
export const ERROR_PROJECTS: Record<string, string> = {
  web: "Web",
  api: "API",
  office: "Office",
};

/** Support threads (product decision 2026-10-13): reading is not answering. */
export const SUPPORT_STATUS: Record<string, { label: string; color: string }> = {
  AWAITING: { label: "Cevap bekliyor", color: "red" },
  ANSWERED: { label: "Cevaplandı", color: "blue" },
  RESOLVED: { label: "Çözüldü", color: "green" },
};

export const PROFILE_CHANGE_FIELDS: Record<string, string> = {
  PHOTO: "Profil fotoğrafı",
  VIDEO: "Profil videosu",
  BIO: "Hakkımda",
  NAME: "Ad soyad",
  SUBJECTS: "Dersler",
};

export const PROFILE_CHANGE_STATUS: Record<string, { label: string; color: string }> = {
  PENDING: { label: "Bekliyor", color: "gold" },
  APPROVED: { label: "Onaylandı", color: "green" },
  REJECTED: { label: "Reddedildi", color: "red" },
};

export const VERIFICATION_STATUS: Record<string, { label: string; color: string }> = {
  PENDING: { label: "İncelemede", color: "gold" },
  VERIFIED: { label: "Onaylı", color: "green" },
  REJECTED: { label: "Reddedildi", color: "red" },
  SUSPENDED: { label: "Pasif", color: "volcano" },
  UNVERIFIED: { label: "Başvuruyu dolduruyor", color: "default" },
};

export const DOCUMENT_TYPES: Record<string, string> = {
  GRADUATION_CERTIFICATE: "E-devlet öğrenci veya mezuniyet belgesi",
  RESIDENCE_CERTIFICATE: "İkametgah belgesi",
};

export const DEGREES: Record<string, string> = {
  BACHELOR: "Lisans",
  MASTER: "Yüksek lisans",
  DOCTORATE: "Doktora",
};

export const GENDERS: Record<string, string> = {
  FEMALE: "Kadın",
  MALE: "Erkek",
  PREFER_NOT_TO_SAY: "Belirtmek istemiyor",
};

export const REVIEW_STATUS: Record<string, { label: string; color: string }> = {
  PENDING: { label: "Bekliyor", color: "gold" },
  APPROVED: { label: "Yayında", color: "green" },
  REJECTED: { label: "Reddedildi", color: "red" },
};

export const CANCELLATION_REQUEST_STATUS: Record<string, { label: string; color: string }> = {
  PENDING: { label: "Bekliyor", color: "gold" },
  APPROVED: { label: "Onaylandı", color: "green" },
  REJECTED: { label: "Reddedildi", color: "red" },
  LAPSED: { label: "Süresi geçti", color: "default" },
};

/** Same labels as the application (apps/web/src/features/lessons/cancellation.ts). */
export const CANCELLATION_REASONS: Record<string, string> = {
  SCHEDULE_CHANGE: "Programım değişti",
  ILLNESS: "Hastalık",
  TECHNICAL_ISSUE: "Teknik sorun",
  OTHER_TUTOR: "Başka bir eğitmenle çalışacağım",
  OTHER: "Diğer",
};

export const ORDER_STATUS: Record<string, { label: string; color: string }> = {
  PENDING: { label: "Bekliyor", color: "gold" },
  PAID: { label: "Ödendi", color: "green" },
  FAILED: { label: "Başarısız", color: "red" },
  CANCELLED: { label: "Vazgeçildi", color: "default" },
  REFUNDED: { label: "İade edildi", color: "purple" },
};

export const ORDER_TYPES: Record<string, string> = {
  INITIAL: "İlk paket",
  UPGRADE: "Yükseltme",
  RENEWAL: "Yenileme",
};

export const PAYOUT_STATUS: Record<string, { label: string; color: string }> = {
  REQUESTED: { label: "Ödenecek", color: "gold" },
  PAID: { label: "Ödendi", color: "green" },
};

const lira = new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" });

/** Money is stored in kuruş (docs/DATABASE.md → Conventions). */
export const formatKurus = (kurus: number) => lira.format(kurus / 100);

export const LESSON_STATUS: Record<string, { label: string; color: string }> = {
  SCHEDULED: { label: "Planlandı", color: "blue" },
  COMPLETED: { label: "Tamamlandı", color: "green" },
  CANCELLED: { label: "İptal edildi", color: "default" },
};

export const SCHOOL_GRADES: Record<string, string> = {
  GRADE_9: "9. Sınıf",
  GRADE_10: "10. Sınıf",
  GRADE_11: "11. Sınıf",
  GRADE_12: "12. Sınıf",
  GRADUATE: "Mezun",
};

export const SUBSCRIPTION_STATUS: Record<string, { label: string; color: string }> = {
  ACTIVE: { label: "Aktif", color: "green" },
  PAST_DUE: { label: "Ödeme bekliyor", color: "orange" },
  CANCELLED: { label: "Yenilenmeyecek", color: "default" },
  EXPIRED: { label: "Sona erdi", color: "default" },
};

export const HOUR_REASONS: Record<string, string> = {
  WEEKLY_GRANT: "Haftalık saat",
  BOOKING: "Ders rezervasyonu",
  BOOKING_REFUND: "İptal iadesi",
  TUTOR_CANCELLATION_CREDIT: "Eğitmen iptali ek kredisi",
  ADMIN_ADJUSTMENT: "Ekip düzeltmesi",
};

export const HOUR_BUCKETS: Record<string, string> = {
  WEEKLY: "Haftalık",
  EXTRA_CREDIT: "Ek kredi",
};

/** "1 Ay", "Yıllık" or the season's name ("2027 Dönemi"). */
export const durationName = (plan: {
  durationMonths: number | null;
  season?: { name: string } | null;
}) =>
  plan.season
    ? plan.season.name
    : plan.durationMonths === 12
      ? "Yıllık"
      : `${plan.durationMonths ?? 1} Ay`;

/** "4 saat/hafta · 3 Ay" or "4 saat/hafta · 2027 Dönemi" for a plan. */
export const planLabel = (plan: {
  weeklyHours: number;
  durationMonths: number | null;
  season?: { name: string } | null;
}) => `${plan.weeklyHours} saat/hafta · ${durationName(plan)}`;

export const DATE_FORMAT = "DD.MM.YYYY";

export const DATE_TIME_FORMAT = "DD.MM.YYYY HH:mm";

/** Copy buttons: tooltip and accessible name (Ant Design says "Copy" otherwise). */
export const COPY_TOOLTIPS: [string, string] = ["Kopyala", "Kopyalandı"];

// Frequent reasons offered when rejecting or making passive (product decision 2026-10-13).
export const TUTOR_REJECT_REASONS = [
  "Başvuru videosunda sorular cevaplanmamış.",
  "Belgeler okunmuyor veya eksik.",
  "Mezuniyet / öğrencilik belgesi verilen derslerle uyuşmuyor.",
  "Profil fotoğrafı uygun değil (arka plan beyaz olmalı, yüz net görünmeli).",
  "Hakkımda yazısı yetersiz.",
] as const;

export const DEACTIVATE_REASONS = [
  "Derslere sürekli geç kalıyor veya katılmıyor.",
  "Öğrenci şikâyetleri.",
  "Platform dışına yönlendirme girişimi.",
  "Eğitmenin kendi isteği.",
] as const;

export const PROFILE_CHANGE_REJECT_REASONS: Record<string, readonly string[]> = {
  PHOTO: [
    "Fotoğrafta yüz net görünmüyor.",
    "Arka plan beyaz değil.",
    "Fotoğraf profesyonel değil.",
  ],
  VIDEO: [
    "Ses veya görüntü kalitesi düşük.",
    "Video 1 dakikayı aşıyor veya kesik.",
    "Videoda iletişim bilgisi veya başka platform geçiyor.",
    "Video öğrencilere uygun değil.",
  ],
  BIO: [
    "İletişim bilgisi veya link içeriyor.",
    "Yazım hataları var.",
    "Doğrulanamayan iddialar içeriyor.",
  ],
  NAME: ["Ad soyad kimlikle uyuşmuyor.", "Takma ad kullanılamaz."],
  SUBJECTS: ["Bu dersler için belge yok.", "Eğitim bilgisiyle uyuşmuyor."],
};
